module.exports = __webpack_public_path__ + "static/smarty_white-e0d7a5acd7e8829fdf2e924a0a544972.png";